import { baseQueryWithReauth } from './baseQuery';
import { CompanyRolesResponse } from '../redux/types';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const companyApi = createApi({
    reducerPath: 'empresa',
    tagTypes: ['Empresas', 'EmpresaById'],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        createEmpresa: builder.mutation({
            query: (body) => ({
                url: `/empresas`,
                method: 'POST',
                body: body
            })
        }),
        editEmpresa: builder.mutation({
            query: ({ body, idEmpresa }) => ({
                url: `/empresas/${idEmpresa}`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Empresas', 'EmpresaById'])
        }),
        editEmpresaState: builder.mutation({
            query: ({ body, idEmpresa }) => ({
                url: `/empresas/${idEmpresa}/estado`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Empresas', 'EmpresaById'])
        }),
        getParametricData: builder.query<CompanyRolesResponse, void>({
            query: () => ({ url: 'empresas/datos-parametricos' }),
            keepUnusedDataFor: 60 * 60 * 12,
            transformResponse: (response: { data: any }) => response?.data
        }),
        getEmpresas: builder.query({
            queryFn(args, api, extraOptions, baseQuery) {
                const filters = { ...args };
                let url: string = 'empresas?';
                Object.entries(filters).forEach(([key, value]: any, index) => {
                    if (key === 'perfiles') {
                        value?.forEach((p: number, index: number) => {
                            url =
                                url +
                                `perfiles=${p}${index < Object.keys(value).length - 1 ? '&' : ''}`;
                        });
                    } else {
                        url =
                            url +
                            `${key}=${value}${index < Object.keys(filters).length - 1 ? '&' : ''}`;
                    }
                });
                return baseQuery({
                    url: url
                });
            },
            providesTags: ['Empresas']
        }),
        getCertificatesByIdBuque: builder.query({
            query: (idBuque) => ({ url: `buques/${idBuque}/certificados` }),
            transformResponse: (response: { data: any }) => response?.data
        }),
        getEmpresa: builder.query({
            query: (idEmpresa) => ({ url: `empresas/${idEmpresa}` }),
            providesTags: ['EmpresaById'],
            transformResponse: (response: { data: any }) => response?.data
        }),
        getComunicaciones: builder.query({
            query: () => ({ url: '/empresas/comunicaciones/certificados' }),
            providesTags: ['Empresas']
        }),
        editComunicacionCertificado: builder.mutation({
            query: ({ body, idCertificado }) => ({
                url: `/empresas/comunicaciones/certificados/${idCertificado}`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Empresas'])
        }),
        getComunicacionesEventos: builder.query({
            query: () => ({ url: '/empresas/comunicaciones/eventos' }),
            providesTags: ['Empresas']
        }),
        editComunicacionEventos: builder.mutation({
            query: ({ body, id }) => ({
                url: `/empresas/comunicaciones/eventos/${id}`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Empresas'])
        }),
        editComunicacionEventosUsers: builder.mutation({
            query: ({ body, id }) => ({
                url: `/empresas/comunicaciones/eventos/${id}/usuarios`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Empresas'])
        }),
        editComunicacionEventosPerfil: builder.mutation({
            query: ({ body, idParametroEventoPerfil }) => ({
                url: `/empresas/comunicaciones/eventos/perfil/${idParametroEventoPerfil}`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Empresas'])
        })
    })
});

export const {
    useGetEmpresaQuery,
    useCreateEmpresaMutation,
    useLazyGetParametricDataQuery,
    useGetParametricDataQuery,
    useEditEmpresaMutation,
    useEditEmpresaStateMutation,
    useGetEmpresasQuery,
    useLazyGetEmpresaQuery,
    useGetComunicacionesQuery,
    useEditComunicacionCertificadoMutation,
    useGetComunicacionesEventosQuery,
    useEditComunicacionEventosMutation,
    useEditComunicacionEventosUsersMutation,
    useEditComunicacionEventosPerfilMutation
} = companyApi;
